// extracted by mini-css-extract-plugin
export var activeDot = "_2q-c";
export var buttonContainer = "_2q-9";
export var channelButton = "_2q-a";
export var clickable = "_2q-d";
export var content = "_2q-0";
export var contentFull = "_2q-2";
export var contentThird = "_2q-1";
export var contentWrapper = "_2q-7";
export var description = "_2q-5";
export var heightShort = "_2q-f";
export var image = "_2q-3";
export var imageContainer = "_2q-4";
export var selectButton = "_2q-e";
export var spinnerContainer = "_2q-b";
export var titleContent = "_2q-8";
export var titleWrapper = "_2q-6";